/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/26/22
 */

import React, { ReactNode } from "react";
import {Stack, Typography, Alert, AlertTitle} from "@mui/material";
import {getAttributeLabel} from "../string-helper";

export interface ErrorsDisplayProps {
	errors: Record<string, string | ReactNode>
}

export default function ErrorsDisplay({errors}: ErrorsDisplayProps) {

	return (
		<Stack sx={{ width: "100%", p: 1, pt: 0, pb: 3 }}>
			<Alert severity="error" variant={"outlined"}>
				<AlertTitle>Validation errors:</AlertTitle>
				{Object.keys(errors).map(attr =>
					<div key={attr}>
						<Typography><b>[{getAttributeLabel(attr)}]: </b>{errors[attr] || "Value is required"}</Typography>
					</div>
				)}
			</Alert>
		</Stack>
	);

}